export default __webpack_public_path__ + "static/media/server-lsbd.e8796e2d.jpg";